import api from "../../utils/Api";

const BackendAdminApiBaseUrl = process.env.REACT_APP_ADMIN_URL;
const employerApi = {    
    async listEmployer(params){
        const response = await api.get( BackendAdminApiBaseUrl + '/employer/' + params);
        return response;
    },

    async suggestionEmployer(data){
        const response = await api.get( BackendAdminApiBaseUrl + '/employer/suggestionEmp/'+ data);
        return response;
    }
}

export default employerApi;